export const CREATE_SHIFT_CHANGE_SHIFT_NAME = 'create-shift/change-shift-name';
export const CREATE_SHIFT_CHANGE_SHIFT_BRANCHES = 'create-shift/change-shift-branches';
export const CREATE_SHIFT_CHANGE_STEP_COUNTER_NEXT = 'create-shift/change-shift-counter-next';
export const CREATE_SHIFT_CHANGE_STEP_COUNTER_PREVIOUS = 'create-shift/change-shift-counter-previous';
export const CREATE_SHIFT_CHANGE_STEP_COUNTER_CHANGE_INDEX = 'create-shift/change-shift-counter-change-index';
export const CREATE_SHIFT_CHANGE_SELECT_WEEK_DAY = 'create-shift/change-select-week-day';
export const CREATE_SHIFT_CHANGE_SHIFT_START_TIME = 'create-shift/change-shift-start-time';
export const CREATE_SHIFT_CHANGE_SHIFT_END_TIME = 'create-shift/change-shift-end-time';
export const CREATE_SHIFT_CHANGE_NUMBER_IN_THE_SHIFT = 'create-shift/change-number-in-the-shift';
export const CREATE_SHIFT_CHANGE_USER_ROLES = 'create-shift/change-users-roles';
export const CREATE_SHIFT_CHANGE_BREAKS = 'create-shift/change-breaks';
export const CREATE_SHIFT_ENTER_BREAK_NAME = 'create-shift/enter-break-name';
export const CREATE_SHIFT_ENTER_USER_ROLE = 'create-shift/enter-user-role';
export const CREATE_SHIFT_ENTER_BREAK_TIME = 'create-shift/enter-break-time';
export const CREATE_SHIFT_ADD_NEW_BREAK = 'create-shift/add-new-break';
export const CREATE_SHIFT_REMOVE_BREAK = 'create-shift/remove-break';
export const CREATE_SHIFT_CHANGE_COMMISSION_TYPE = 'create-shift/change-commission-type';
export const CREATE_SHIFT_CHANGE_ACTIVITY_TRACKER_MODE = 'create-shift/change-activity-tracker-mode';
export const CREATE_SHIFT_CHANGE_ACTIVITY_TRACKER_VALUE = 'create-shift/change-activity-tracker-value';
export const CREATE_SHIFT_CHANGE_MOTION_TRACKER_MODE = 'create-shift/change-motion-tracker-mode';
export const CREATE_SHIFT_CHANGE_MOTION_TRACKER_VALUE = 'create-shift/change-motion-tracker-value';

export const CREATE_SHIFT_COMMISSION_INDIVIDUAL = 'create-shift/change-commission-individual';
export const CREATE_SHIFT_COMMISSION_INDIVIDUAL_ADD = 'create-shift/change-commission-individual/add';
export const CREATE_SHIFT_COMMISSION_INDIVIDUAL_REMOVE = 'create-shift/change-commission-individual/remove';

export const CREATE_SHIFT_COMMISSION_USER_GROUP = 'create-shift/change-user-group';
export const CREATE_SHIFT_COMMISSION_USER_GROUP_ADD = 'create-shift/change-user-group/add';
export const CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE = 'create-shift/change-user-group/remove';
export const CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_INDIVIDUAL =
  'create-shift/change-user-group/remove-individual';
export const CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_PER_VEHICLE =
  'create-shift/change-user-group/remove-per-vehicle';
export const CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_TEAM = 'create-shift/change-user-group/remove-team';
export const CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_INDIVIDUAL = 'create-shift/change-user-group/add-individual';
export const CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_PER_VEHICLE = 'create-shift/change-user-group/add-per-vehicle';
export const CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_TEAM = 'create-shift/change-user-group/add-team';

export const CREATE_SHIFT_COMMISSION_PER_VEHICLE = 'create-shift/change-per-vehicle';
export const CREATE_SHIFT_COMMISSION_PER_VEHICLE_ADD = 'create-shift/change-per-vehicle/add';
export const CREATE_SHIFT_COMMISSION_PER_VEHICLE_REMOVE = 'create-shift/change-per-vehicle/remove';

export const CREATE_SHIFT_COMMISSION_ADD_TIER = 'create-shift/add-tier';
export const CREATE_SHIFT_COMMISSION_REMOVE_TIER = 'create-shift/remove-tier';
export const CREATE_SHIFT_COMMISSION_CHANGE_TIER_VALUE = 'create-shift/change-tier-value';

export const CREATE_SHIFT_SET_EXISTING_DATA = 'create-shift/set-existing-data';

export const CREATE_SHIFT_RESET_STATE = 'create-shift/reset-state';

export const CREATE_NEW_STEP_FILLED = 'create-shift/new-section-filled';
